import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import {
    Nav, Button, Modal,
    // Col,
    // Form, Alert,
} from 'react-bootstrap'
// import GoogleLogin from 'react-google-login';
// import { bindActionCreators } from "redux";
// import { connect } from "react-redux";
import LoginPage from "./LoginPage"
import ForgotPassword from "./ForgotPass";
import "bootstrap/dist/css/bootstrap.min.css";

// Assets

// Components

const LoginButton = (props) => {
    const [show, setShow] = useState(false)

    // constructor(props) {
    //     super(props)

    //     this.handlerLogin = this.handlerLogin.bind(this)
    // }
    // state = {
    //     show: true,
    //     hide: false
    // };
    // handlerLogin() {
    //     this.setState({ show: !this.state.show });
    // }

    if (window.location.pathname === "/login") {
        return <></>
    }

    return (
        <Nav.Link eventKey={2}>
            {/* <LoginButtonModal /> */}
            <Button id="loginButton" variant="primary" onClick={() => setShow(true)}>
                <div style={{ fontSize: 14, fontFamily: "poppins" }}>
                    Login/Sign up
                </div>
            </Button>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                // size="lg"
                dialogClassName="d-flex justify-content-center"
                centered
                contentClassName="w-dialog d-flex justify-content-center align-items-center user-select-none"
                backdrop={true}
                backdropClassName="login-modal-backdrop"
                onExited={() => setShow(false)}
            >
                <Modal.Body>
                    {/* {show ? <LoginPage handlerLogin={this.handlerLogin.bind(this)} /> : <ForgotPassword handlerLogin={this.handlerLogin.bind(this)} />} */}
                    {show ? <LoginPage show={show} /> : <ForgotPassword />}
                </Modal.Body>
            </Modal>
        </Nav.Link>
    );
};

export default LoginButton;
